import { useAlert } from 'dashboard/composables';
import {
  isMasifiWaGroupChat,
  masifiWaGroupMuteI18n,
  masifiWaGroupUnmute,
} from 'dashboard/helper/masifi/masifiWaGroups';

// "Silenciar grupo" / "Reactivar grupo" en el menú de la conversación (MoreActions.vue; E2E fix 5 y 6, Marcos
// 2026-09-24). Touchpoint SIN editar líneas de upstream (E2E fix 8, regla 11c): el `t` nativo queda intacto y estas
// dos funciones envuelven el comportamiento desde afuera, 1 línea por punto de uso:
// - masifiWaGroupMuteLabels: antes del `return items` de `actionMenuItems`, re-rotula mute/unmute en un GRUPO;
// - masifiWaGroupMute: al inicio del flujo de mute/unmute (menú y barra de comandos). En un GRUPO hace el mute nativo
//   con el aviso "Grupo silenciado", o el "Reactivar grupo" en orden (masifiWaGroupUnmute), y devuelve truthy para que
//   el flujo nativo no corra. 1:1 / otra acción → null y sigue el nativo intacto.
const groupT = (t, chat) => masifiWaGroupMuteI18n({ t }, () => chat).t;
const LABEL_KEYS = {
  mute: 'CONTACT_PANEL.MUTE_CONTACT',
  unmute: 'CONTACT_PANEL.UNMUTE_CONTACT',
};

export const masifiWaGroupMuteLabels = (items, chat, t) => {
  if (!isMasifiWaGroupChat(chat)) return;
  items.forEach(item => {
    if (LABEL_KEYS[item.action])
      item.label = groupT(t, chat)(LABEL_KEYS[item.action]);
  });
};

export const masifiWaGroupMute = (action, chat, store, t) => {
  if (!isMasifiWaGroupChat(chat)) return null;
  if (action === 'mute') {
    store.dispatch('muteConversation', chat.id);
    useAlert(groupT(t, chat)('CONTACT_PANEL.MUTED_SUCCESS'));
    return true;
  }
  if (action === 'unmute')
    return masifiWaGroupUnmute(store, chat, groupT(t, chat), useAlert);
  return null;
};
